// @ts-nocheck
import type { ReactNode } from 'react';
import { forwardRef, useMemo } from 'react';

import type { TransformedPointOfSaleReport } from '@ballerine/common';
import type { CustomerFeatures } from '@ballerine/customer-schemas';

import type { PreviousReportsLinks } from '../../../report-shared/components/PreviousReportsButton/PreviousReportsButton';
import { BaseReport } from '../../../reports/BaseReport';
import { usePointOfSaleReportSections } from '../../hooks/usePointOfSaleReportSections/usePointOfSaleReportSections';

type PointOfSaleReportProps = {
  report: TransformedPointOfSaleReport & {
    monitoringStatus?: string | null;
    changesSummary?: string | null;
    isAlert?: boolean | null;
    comparedToReportId?: string | null;
  };
  reportType?: string;
  customerFeatures?: CustomerFeatures | null;
  disableSectionObserver?: boolean;
  FeedbackComponent?: React.ComponentType<{ reportId: string }>;
  header?: ReactNode;
  googleMapsApiKey?: string;
  previousReportsLinks?: PreviousReportsLinks | null;
  Link: React.ComponentType<{
    to: string;
    children: React.ReactNode;
    className?: string;
  }>;
};

export const PointOfSaleReport = forwardRef<HTMLDivElement, PointOfSaleReportProps>(
  (
    {
      report,
      reportType,
      disableSectionObserver = false,
      FeedbackComponent,
      header,
      googleMapsApiKey,
      previousReportsLinks,
      Link,
    },
    ref,
  ) => {
    const computedPreviousReportsLinks = useMemo(() => {
      if (previousReportsLinks) {
        return previousReportsLinks;
      }

      const comparedToReportId = (report as any).comparedToReportId;

      if (!comparedToReportId) {
        return null;
      }

      return {
        previousMonitoringReportHref: `/point-of-sale/${comparedToReportId}`,
        onboardingReportHref: null,
      };
    }, [report, previousReportsLinks]);

    const { sections } = usePointOfSaleReportSections(
      report,
      googleMapsApiKey,
      FeedbackComponent,
      Link,
      reportType,
      computedPreviousReportsLinks,
    );

    return (
      <BaseReport
        ref={ref}
        sections={sections}
        disableSectionObserver={disableSectionObserver}
        header={header}
      />
    );
  },
);

PointOfSaleReport.displayName = 'PointOfSaleReport';
